<template >
    <!-- section 1 -->
    <section class=" flexmobile2  mx-auto md:px-20  mt-32">
        <h1 class="self-start text-4xl font-semibold text-white">Storyboarding (Big Picture) </h1>
    <section class="flex  flex-col font-semibold mt-12">
    <div class="  flexmobile2 flex gap-6 text-white justify-between">
    <div class="w-full md:w-1/5">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671265/story1_fxqqqm.png" alt="">
        <p>Relocates to a new city for the first time ever</p>
    </div>
    <div class="w-full md:w-1/5">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671275/storyBoard_1_ajxyeo.png" alt="">
        <p>Feels homesick and confused </p>
    </div>
    <div class="w-full md:w-1/5">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671341/story3_xwkzly.png" alt="">
        <p>Randomly find NextHome app browsing through AppStore</p>
    </div>
    <div class="w-full md:w-1/5">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671370/story4_rh8sfx.png" alt="">
        <p>Impressed with the app's description decides to give it a try</p>
    </div>
    <div class="w-full md:w-1/5">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671352/story5_ercykl.png" alt="">
        <p>Sets her budget using the budget filter</p>
    </div>
    
    </div>
    <div class="  pt-10 flex flexmobile2 gap-6 text-white justify-between">
    <div class="w-full md:w-1/5">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671429/story6_lpwe79.png" alt="">
        <p>Learns the "local Lingo", using app's language assistance</p>
    </div>
    <div class="w-full md:w-1/5">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671465/story7_ptkr9v.png" alt="">
        <p>Makes new friends using the "Meet & Greet" feature </p>
    </div>
    <div class="w-full md:w-1/5">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671450/story8_ccnehv.png" alt="">
        <p>Finds hidden food gems in the city by exploring "Food & Drinks" feature</p>
    </div>
    <div class="w-full md:w-1/5">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671492/story9_xcjoke.png" alt="">
        <p>Visits Tourist places using "Travel" feature</p>
    </div>
    <div class="w-full md:w-1/5">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671599/story10_tox7oz.png" alt="">
        <p>Feels grateful to have NextHome app </p>
    </div>
    
    </div>
    </section>
    </section>
    <!-- section 2 -->
    <section class="md:px-20 mx-auto mt-32 " >
    <div class="flex flexmobile2 justify-between">
      <section class="flex flex-col items-start rounded-none max-w-[636px]">
        <h1 class="self-start text-4xl font-semibold text-white">Introducing NextHome</h1>
        <article class=" text-white max-md:mt-10 max-md:max-w-full ml-12 mt-10">
          <p class="pt-6 text-lg md:pb-6">
            NextHome is a responsive application that is designed for individuals who have recently relocated. Getting settled in an entirely new place is hard. To make this process a little easier,
          </p>
          <p class=" pt-6 text-lg ">NextHome allows its users to:</p>
          <ol class="text-lg  list-disc ml-8">
            <li class="pt-6 text-lg "><span class="text-sky-200  ">Connect with people</span></li>
            <li class="pt-6 text-lg "><span class="text-sky-200 ">Explore top rated restaurants</span></li>
            <li class="pt-6 text-lg "><span class="text-sky-200 ">Learn the local lingo</span></li>
            <li class="pt-6 text-lg "><span class="text-sky-200 ">Explore tourist attractions</span></li>
          </ol>
          <p class=" pt-6 text-lg md:pb-6">
            It empathizes with the users by using the <span class="text-sky-200">budget filter</span>, without burning a hole in their pockets.
          </p>
        </article>
      </section>
      <section class="animate__animated" ref="section2">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671673/iPhone_13_s53nbj.png" alt="">
      </section>
    </div>
    </section>
    <!-- section 3 -->
    <section class=" mx-auto px-4 md:px-20 mt-10 md:mt-56">
        <h1 class="self-start text-4xl font-semibold text-white">In a nutshell</h1>

  <section class="md:w-full">
    <div class="flex flex-col md:flex-row justify-between md:gap-10">
      
      <!-- User Frustrations -->
      <div class="w-full md:w-[45%] mt-8">
        <p class="text-sky-200 text-2xl md:text-3xl font-semibold pt-6 ml-8">User Frustrations</p>
        <ul class="text-white pt-8 text-lg md:pb-6 space-y-4 ml-8">
          <li>Cannot find all the information in one place</li>
          <li>Issues in exploring budget friendly options</li>
          <li>Difficulty in networking and meeting new people</li>
          <li>Language acts as a barrier for non-native speakers</li>
          <li>Challenges navigating in a new place</li>
          <li>Researching and finding local restaurants can be time consuming</li>
        </ul>
      </div>
      <div class="hiddenMobile">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726670445/nextline_omtelj.png" alt="">
      </div>
      <!-- Implemented Features -->
      <div class="w-full md:w-[45%] mt-8">
        <p class="text-sky-200 text-2xl md:text-3xl font-semibold pt-6">Implemented Features</p>
        <ul class="text-white pt-8 text-lg md:pb-6 space-y-4">
          <li>The web app is a central information hub</li>
          <li><span class=" text-sky-200">Budget filter</span> lets the user set the budget</li>
          <li><span class=" text-sky-200">"Meet & Greet"</span> feature helps connect with both groups and individuals</li>
          <li><span class=" text-sky-200">"Local Lingo"</span> feature helps users to learn the local language and slangs</li>
          <li><span class=" text-sky-200">"Explore"</span> feature helps to navigate and explore tourist destinations</li>
          <li><span class=" text-sky-200">"Food & Drinks"</span> feature suggests various restaurants based on cuisine with ratings</li>
        </ul>
      </div>
      
    </div>
  </section>
    </section>
    <!-- section 4 -->
    <section class=" mx-auto px-4 md:px-20 mt-10 md:mt-56 " >
    <section class="flex flex-col  rounded-none">
     <h1 class="self-start text-4xl font-semibold text-white">Objectives & Outcomes</h1>
      <ul class="flex flex-col items-start pl-7 mt-10 w-full text-3xl text-sky-200 max-md:pl-5 max-md:mt-10 max-md:max-w-full">
        <li>
          <p class="text-sky-200 text-2xl md:text-3xl font-semibold pt-6">Responsive Design</p>
          <p class="pt-6 text-lg md:pb-6 text-white max-md:max-w-full">
            Design layouts that adapt seamlessly to various screen sizes and orientations. Ensure that the app's functionality remains consistent across devices.
          </p>
        </li>
        <li class="mt-32 max-md:mt-10 max-md:ml-1">
          <p class="text-sky-200 text-2xl md:text-3xl font-semibold pt-6">Mobile-First Approach</p>
          <p class="pt-6 text-lg md:pb-6 text-white max-md:max-w-full">
            Prioritizes mobile design due to the likelihood of users accessing information on-the-go during their relocation journey.
          </p>
        </li>
      </ul>
    </section>
    <section ref="section4" class=" animate__animated flex justify-center">
      <img loading="lazy" src="https://res.cloudinary.com/dvkj5orhe/image/upload/v1731292481/fy760ym90h7qlvo9jlv2.png" alt="">
    </section>
    </section>
    <!-- section 5 -->
    <section class=" mx-auto px-4 md:px-20 mt-10 md:mt-56 ">
   <section>
    <p class="text-sky-200 text-2xl md:text-3xl font-semibold pt-6">Comprehensive Information Hub</p>
    <p class="pt-6 text-lg md:pt-8 text-white max-md:max-w-ful">Facilitates access to a variety of information that is essential for settling into a new location in one place.</p>
   </section>
   <section class="mt-16 justify-center flex">
    <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671752/phonenext1_zihbn8.png" alt="">
   </section>
    </section>
    <!-- section 6 -->
    <section class="mx-auto px-4 md:px-20 mt-10 md:mt-56 ">
   <section>
    <p class="text-sky-200 text-2xl md:text-3xl font-semibold pt-6">Accessibility Enhancement</p>
    <p class="dancing-script text-white text-2xl md:text-3xl font-semibold pt-10">Voice Command support</p>
    <p class="pt-6 text-lg md:pb-6 text-white">Enable hands-free interaction, allowing users to navigate and control devices using their voice, fostering accessibility for those who may face challenges with traditional input methods.</p>
   </section>
   <section class="mt-16 justify-center flex">
    <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671781/phonenext2_rqi7ar.png" alt="">
   </section>
    </section>
    <!-- section 7 -->
    <section class=" flexmobile2 mx-auto px-4 md:px-20 mt-10 md:mt-32 ">
    <section>
    <p class="text-sky-200 text-2xl md:text-3xl font-semibold pt-6">Localization</p>
    <p class="dancing-script text-white text-2xl md:text-3xl font-semibold pt-8">Geo-Targeting</p>
    </section>
    <section class="mt-20 flexmobile2 justify-between flex">
    <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671811/phonenext3_qu7jbn.png" alt="">
    <p class="pt-6 mt-24 ml-16 text-lg md:pb-6 text-white max-md:max-w-ful">Location-based services to provide users with relevant information about their new city, including nearby attractions, events, and local services.</p>
    </section>
   <section class=" mt-20">
    <p class="dancing-script text-white text-2xl md:text-3xl font-semibold pt-6">Language Learning</p>

<section class="flexmobile2 justify-between flex">
<p class="pt-6 text-lg md:pt-16 text-white">Language learning resources based on user preferences and language proficiency levels.</p>
<div class="flex flexmobile2 ml-16">
    <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671862/Group_34314_tsagsd.png" alt="">
    <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671882/Group_34311_zwwyhz.png" alt="">
</div>
</section>
   </section>
    </section>
    <!-- section 8 -->
    <section class=" mx-auto px-4 md:px-20 mt-10 md:mt-56 ">
    <section>
    <p class="text-sky-200 text-2xl md:text-3xl font-semibold pt-6">Personalization</p>
    <p class="pt-6 text-lg md:pb-6 text-white max-md:max-w-ful">Allows the user to set their desired budget range and and choose from a list of suggestions that helps them explore, without burning a hole in their pocket.</p>
    </section>
    <section class="mt-4 justify-center flex">
    <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671935/Group_82_npcmxw.png" alt="">
    </section>
    </section>
    <!-- section 9 -->
    <section class=" flexmobile2 mx-auto mt-40 px-20 first-line:mt-32">
    <h1 class="self-start text-4xl font-semibold text-white">High Fidelity Screens</h1>
    <p class="text-sky-200 text-2xl md:text-3xl font-semibold pt-12">Mobile Screens</p>
    <div class=" flex flexmobile2 justify-between mt-12">
        <section>
            <p class=" text-center pb-10 text-2xl dancing-script text-sky-200">Landing Screen</p>
            <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726672325/Group_34316_airlei.png" alt="">
        </section>
        <section class="md:mt-96">
            <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726672312/Group_34315_mkrcxv.png" alt="">
        </section>
        <section>
            <p class=" text-center pb-10 text-2xl dancing-script text-sky-200">Input Screen</p>
            <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726672246/Group_34317_cqfjsq.png" alt="">
        </section>
    </div>
    </section>
    <!-- section 10 -->
     <section class=" container mx-auto mt- px-20">  <section class="rounded-none">
    <div class="flex gap-5 max-md:flex-col">
        <img loading="lazy" class="hiddenMobile mt-[35rem] max-h-[35rem]" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726672423/Home_Screen_xryepf.png" alt="">
      <aside class="flex flex-col w-[39%] max-md:ml-0 max-md:w-full">
        
        <div class="flex flex-col self-stretch my-auto text-lg font-medium text-center text-amber-50 max-md:mt-10">
            <h2>Live Weather updates to keep the users informed</h2>
          <p class="mt-72 max-md:mt-10">Few words to motivate the newly relocated users</p>
        </div>
      </aside>
      <main class="flex flex-col  mx-auto w-[61%] max-md:ml-0 max-md:w-full">
        <div class="flex flex-col grow text-lg font-medium text-center text-amber-50 max-md:mt-10 max-md:max-w-full">
          <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/fefad33d80a6cddf4baaae909977dc6ec894989cf650e256cb3050f59a2c735b?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" class="object-contain self-center w-0.5 aspect-[0.01] stroke-[2px] stroke-white" alt="" />
          <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/95b10b2363d6c11251c9c432ba22417e89fd71c2f3a360091aeac1666e24c163?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" class="object-contain self-center w-4 aspect-square" alt="" />
          <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/1513838772eebad914f94f54c992b409b1025f0e1575ce7452e9f9fc517ad498?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" class="object-contain mt-11 w-full rounded-none aspect-[0.44] max-md:mt-10 max-md:max-w-full" alt="Weather information display" />
          <p class="self-end mt-9 mr-7 max-md:mr-2.5">Words of wisdom to help users easily blend in</p>
        </div>
      </main>
    </div>
  </section> 
     </section>
    </template>

<script>
export default {
  name: 'NextProjectTwo',
  mounted() {
    const options = {
      threshold: 0.5 // Trigger animation when 50% of the element is in view
    };

    const animateOnView = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate__pulse');
          observer.unobserve(entry.target); // Stop observing once the animation is triggered
        }
      });
    };

    // Create an IntersectionObserver instance
    const observer = new IntersectionObserver(animateOnView, options);

    // Observe the sections you want to animate
    observer.observe(this.$refs.section2);
    observer.observe(this.$refs.section4);
  }
};
</script>

<style>
.background-next{
    background-image: url("https://res.cloudinary.com/dkdzcp4au/image/upload/v1726670500/nextback_pqpmgd.png");
    background-size: cover;
}
.background-next2{
    background-image: url("https://res.cloudinary.com/dkdzcp4au/image/upload/v1726670500/nextback_pqpmgd.png");
    background-size: contain;
}
.Bakery-Linear{
    background: linear-gradient(90deg, rgba(248,146,146,1) 0%, rgba(137,2,35,1) 35%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

@media (max-width:640px){
    .flexmobile2{
        display: block;
        margin-left: 0;
        padding: 10px;
        gap: 0 !important;
        font-size: 20px;
    }
    
    .max-w-small-mobile{
        max-width: 100%;
        width: 100%;
    }
    .hiddenMobile{
        visibility: hidden;
        display: none;
    }
}

</style>
